import { actions as arcCategoriesActions } from 'domains/arcCategories'

export const fetchArcCategories = (payload) => arcCategoriesActions.fetchArcCategories(payload)

export const createArcCategory = (payload) => arcCategoriesActions.createArcCategory(payload)

export const updateArcCategory = (payload) => arcCategoriesActions.updateArcCategory(payload)

export const deleteArcCategory = (payload) => arcCategoriesActions.deleteArcCategory(payload)